import { CartItem } from '@pedix-workspace/utils';
import {
  PromotionCart,
  PromotionCartItem,
  AppliedPromotion,
} from '@pedix-workspace/shared-promotions';
import {
  getItemType,
  getCartItemSubtotal,
  getItemPrice,
  getOptionsTotal,
  getPresentationsCount,
  getProductOrSinglePresentationQuantity,
} from './cart-item-utils';

export function expandCartItemsToPromotionCart(cartItems: CartItem[]): PromotionCart {
  const items: PromotionCartItem[] = [];

  for (const cartItem of cartItems) {
    const itemType = getItemType(cartItem);

    if (itemType === 'multi-presentation') {
      const totalPresentationUnits = getPresentationsCount(cartItem.selectedPresentation);
      const optionsTotal = getOptionsTotal(cartItem, { usePriceDiscount: true });
      const optionsPerUnit = totalPresentationUnits > 0 ? optionsTotal / totalPresentationUnits : 0;

      for (const presentationItem of cartItem.selectedPresentation.items) {
        if (!presentationItem.quantity || presentationItem.quantity <= 0) continue;

        const unitPrice = getItemPrice(presentationItem, { usePriceDiscount: true });
        const subtotal = (unitPrice + optionsPerUnit) * presentationItem.quantity;

        items.push({
          id: `${cartItem.id}::${presentationItem.id}`,
          productId: cartItem.product.id,
          quantity: presentationItem.quantity,
          subtotal,
          groupKey: `${cartItem.product.id}::${presentationItem.id}`,
        });
      }
    } else {
      const singlePresentationItem = cartItem.selectedPresentation?.items?.[0];
      const groupKey = singlePresentationItem
        ? `${cartItem.product.id}::${singlePresentationItem.id}`
        : cartItem.product.id;

      items.push({
        id: cartItem.id,
        productId: cartItem.product.id,
        quantity: getProductOrSinglePresentationQuantity(cartItem),
        subtotal: getCartItemSubtotal(cartItem, { usePriceDiscount: true }),
        groupKey,
      });
    }
  }

  const subtotal = items.reduce((sum, item) => sum + item.subtotal, 0);

  return { items, subtotal };
}

export function getCartItemSavings(
  cartItemId: string,
  appliedPromotions: AppliedPromotion[],
): number {
  let total = 0;
  const prefix = `${cartItemId}::`;

  for (const promo of appliedPromotions) {
    for (const [itemId, amount] of Object.entries(promo.discountByItemId ?? {})) {
      if (itemId === cartItemId || itemId.startsWith(prefix)) {
        total += amount;
      }
    }
  }

  return total;
}

export function getCartItemPromotions(
  cartItemId: string,
  appliedPromotions: AppliedPromotion[],
): AppliedPromotion[] {
  const prefix = `${cartItemId}::`;

  return appliedPromotions.filter(promo =>
    promo.affectedItemIds.some(id => id === cartItemId || id.startsWith(prefix)),
  );
}
